module.exports = __webpack_public_path__ + "static/img/logo-ionis-education-group.4c95aa1.png";


//////////////////
// WEBPACK FOOTER
// ./static/logo-ionis-education-group.png
// module id = 78HG
// module chunks = 1